/** The words for the group (spec 143, settled 2026-10-07). */
export const ALSO_CHANGED_COPY = {
  heading: (count: number) =>
    `Also changed in the workspace during this run (${String(count)})`,
  explanation:
    "Other tasks were running in this workspace at the same time; these changes can't be credited to this task.",
} as const;
